const template = document.createElement("template");
template.innerHTML = `
<style>
  :host{
    --ctl-font: var(--ctl-font-sans, system-ui,-apple-system,Segoe UI,Roboto,Arial);

    display: block;
    font-family: var(--ctl-font);
  }

  .item{
    display: flex;
    flex-direction: column;
    gap: var(--ctl-space-1-5);
  }

  /* horizontal layout (term and details side-by-side) */
  :host([layout="horizontal"]) .item{
    flex-direction: row;
    align-items: baseline;
    gap: var(--ctl-space-3);
  }

  .term{
    font-size: var(--ctl-font-size-md);
    font-weight: var(--ctl-font-weight-bold);
    color: var(--ctl-color-muted);
    letter-spacing: var(--ctl-tracking-tight);
    line-height: var(--ctl-leading-normal);
  }

  :host([layout="horizontal"]) .term{
    flex-shrink: 0;
    min-width: var(--term-width, 140px);
    max-width: var(--term-width, 140px);
  }

  .details{
    font-size: var(--ctl-font-size-base);
    font-weight: var(--ctl-font-weight-normal);
    color: var(--ctl-color-text);
    line-height: var(--ctl-leading-normal);
    word-break: break-word;
  }

  :host([layout="horizontal"]) .details{
    flex: 1;
    min-width: 0;
  }

  /* copy button slot */
  .details-wrapper{
    display: flex;
    align-items: center;
    gap: var(--ctl-space-2);
  }

  .copy{
    display: flex;
    flex-shrink: 0;
  }

  .copy:empty{
    display: none;
  }
</style>

<div class="item" part="item">
  <div role="term" class="term" part="term">
    <slot name="term"></slot>
  </div>
  <div role="definition" class="details-wrapper" part="details-wrapper">
    <div class="details" part="details">
      <slot></slot>
    </div>
    <div class="copy" part="copy">
      <slot name="copy"></slot>
    </div>
  </div>
</div>
`;

export class CtlDescriptionItem extends HTMLElement {
  static get observedAttributes() {
    return ["term", "layout"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(template.content.cloneNode(true));
    this._termEl = this.shadowRoot.querySelector(".term");
  }

  connectedCallback() {
    this._sync();
  }

  attributeChangedCallback() {
    this._sync();
  }

  // attrs
  get term() { return this.getAttribute("term") || ""; }
  set term(v) { v ? this.setAttribute("term", String(v)) : this.removeAttribute("term"); }

  get layout() { return this.getAttribute("layout") || "vertical"; }
  set layout(v) { this.setAttribute("layout", String(v || "vertical")); }

  _sync() {
    // Allow setting term via attribute for convenience
    const termAttr = this.getAttribute("term");
    if (termAttr && !this.querySelector('[slot="term"]')) {
      this._termEl.textContent = termAttr;
    }

    const layout = this.layout;
    if (!["vertical", "horizontal"].includes(layout)) {
      this.setAttribute("layout", "vertical");
    }
  }
}

customElements.define("ctl-description-item", CtlDescriptionItem);
